import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Facebook,
  Instagram,
  LinkedIn,
  Reddit,
  Twitter,
  YouTube
} from '@mui/icons-material'
import { SvgIcon } from '@mui/material'
import { Box, Button, Menu, Typography } from '@mui/material'

import { ReactComponent as SimIcon } from '../assets/icons/circles-design/SimIcon.svg'
import Billing from '../assets/marketing/Billing.png'
import Discounts from '../assets/marketing/Discounts.png'
import { ReactComponent as HeroImage } from '../assets/marketing/HeroImage.svg'
import IoT from '../assets/marketing/IoT.png'
import MinTerms from '../assets/marketing/MinTerms.png'
import MobilePlans from '../assets/marketing/MobilePlans.png'
import PeripheralDevices from '../assets/marketing/PeripheralDevices.png'
import SameCoy from '../assets/marketing/SameCoy.png'
import Wifi from '../assets/marketing/Wifi.png'
import { DropdownButton } from '../common/ui/dropdowns'

function DemoEntryPt() {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '100vw'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '120px',
          background: '#E5E5E5'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '85vw',
            height: '50%',
            background: 'white',
            opacity: 0.9,
            borderRadius: '100px'
          }}
        >
          <Box>
            <img
              src='https://sg1-sharedresources-dashboardbeepluginuploads3buc-1qsv7f850xocz.s3.amazonaws.com/images/RZK-774-875Z/editor_images/header%20logo.png'
              alt='Circles Logo'
              style={{
                height: '45px'
              }}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-around',
              width: '20vw'
            }}
          >
            <Menu>
              <DropdownButton>Plans</DropdownButton>
              <DropdownButton>Why Us</DropdownButton>
              <DropdownButton>Help</DropdownButton>
            </Menu>
          </Box>
          <Box sx={{ marginRight: '5px' }}>
            <Button variant='filled'>Activate SIM</Button>
          </Box>
        </Box>
      </Box>

      {/* first */}
      <Box
        sx={{
          display: 'flex',
          height: '325px',
          background: '#7a2bd4'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '100%',
            width: '50%',
            marginLeft: '15%'
          }}
        >
          <Typography variant='h2' sx={{ color: 'white' }}>
            Power up your business
          </Typography>
          <Typography variant='h4' sx={{ color: '#75dcf7' }}>
            Choose Singapore&apos;s #1 Recommended Telco <br />
            for all your connectivity needs
          </Typography>
          <Button
            variant='secondary'
            sx={{ width: '200px' }}
            onClick={() => navigate('/onboarding')}
          >
            Submit a request
          </Button>
        </Box>
        <Box>
          <HeroImage height='90%' sx={{ padding: '10px' }} />
        </Box>
      </Box>

      {/* second */}
      <Box
        sx={{
          display: 'flex',
          height: '325px',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Typography variant='h4' sx={{ marginBottom: 0 }}>
            The right plan for your business
          </Typography>
          <Typography variant='subtitle2' sx={{ height: '20px' }}>
            Get customized solutions for your connectivity needs. Easy to order
            and manage.
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                width: '15%',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '20px'
              }}
            >
              <img
                width='100'
                height='100'
                src={MobilePlans}
                alt='Mobile plans and phones for staffs'
              />
              <Typography variant='subtitle2' sx={{ height: '20px' }}>
                Mobile plans and phones for staffs
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                width: '15%',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '20px'
              }}
            >
              <img
                width='100'
                height='100'
                src={PeripheralDevices}
                alt='Peripheral devices (e.g. tablets, walkie talkies, logistics
                handhelds)'
              />
              <Typography variant='subtitle2' sx={{ height: '20px' }}>
                Peripheral devices (e.g. tablets, walkie talkies, logistics
                handhelds)
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                width: '15%',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '20px'
              }}
            >
              <img width='100' height='100' src={IoT} alt='M2M and IoT' />
              <Typography variant='subtitle2' sx={{ height: '20px' }}>
                M2M &amp; IoT{' '}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                width: '15%',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '20px'
              }}
            >
              <img
                width='100'
                height='100'
                src={Wifi}
                alt='WiFi / MiFi for company use'
              />
              <Typography variant='subtitle2' sx={{ height: '20px' }}>
                WiFi / MiFi for company use
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* third */}
      <Box
        sx={{
          display: 'flex',
          height: '325px',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#E5E5E5'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Typography variant='h4' sx={{ marginBottom: 0 }}>
            Tailored for business use
          </Typography>
          <Box display='flex' justifyContent='center' alignItems='center'>
            <Box
              sx={{
                display: 'flex',
                width: '15%',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '20px'
              }}
            >
              <img
                width='100'
                height='100'
                src={SameCoy}
                alt='All your lines under the same company name and registration
                number'
              />
              <Typography variant='subtitle2' sx={{ height: '20px' }}>
                All your lines under the same company name and registration
                number
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                width: '15%',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '20px'
              }}
            >
              <img
                width='100'
                height='100'
                src={MinTerms}
                alt='Shorter minimum terms'
              />
              <Typography variant='subtitle2' sx={{ height: '20px' }}>
                Shorter minimum terms (6 months vs. 24 months)
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                width: '15%',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '20px'
              }}
            >
              <img
                width='100'
                height='100'
                src={Billing}
                alt='Consolidated Billing'
              />
              <Typography variant='subtitle2' sx={{ height: '20px' }}>
                Consolidated Billing{' '}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                width: '15%',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '20px'
              }}
            >
              <img
                width='100'
                height='100'
                src={Discounts}
                alt='Discounts based on order quantity'
              />
              <Typography variant='subtitle2' sx={{ height: '20px' }}>
                Discounts based on order quantity
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* fourth */}
      <Box
        sx={{
          display: 'flex',
          height: '450px',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Typography variant='h4' sx={{ marginBottom: 0 }}>
            How it works
          </Typography>
          <Box display='flex' justifyContent='center' alignItems='center'>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '20px'
              }}
            >
              <SimIcon style={{ margin: '20px 0' }} />
              <Box sx={{ fontFamily: 'roboto' }}>
                <ol>
                  <li> Submit your request through the form here.</li>
                  <li>
                    Our agent will get back to you within 48 hours if we can
                    meet your requirements.
                  </li>
                  <li> Place your order with our consultant.</li>
                  <li>
                    Pick up your SIM cards or have them delivered to your
                    doorstep within 5 working days!
                  </li>
                </ol>
              </Box>
              <Button variant='filled' onClick={() => navigate('/onboarding')}>
                Submit a request
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* footer */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-evenly',
          padding: '30px',
          background: '#333333',
          color: 'white',
          fontSize: '0.5em',
          lineHeight: '2em'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: '1'
          }}
        >
          <Typography variant='h5' sx={{ color: 'white', marginLeft: 0 }}>
            EXPLORE
          </Typography>
          <Box>
            Blog <br />
            Roaming <br />
            Circles.Life App <br />
            Partnership <br />
            Referral Program <br />
            Daily Poll <br />
            Discover <br />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: '1'
          }}
        >
          <Typography variant='h5' sx={{ color: 'white', marginLeft: 0 }}>
            COMPANY
          </Typography>
          <Box>
            About Us <br />
            Careers <br />
            Newsroom <br />
            Terms and Conditions <br />
            Privacy <br />
            Business Solutions <br />
            Report Security Vulnerability <br />
            Security Whitepaper <br />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: '1'
          }}
        >
          <Typography variant='h5' sx={{ color: 'white', marginLeft: 0 }}>
            HELP
          </Typography>
          <Box>
            Contact Us <br />
            Track My Order <br />
            Lost SIM <br />
            FAQs <br />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1
          }}
        >
          <Typography variant='h5' sx={{ color: 'white', marginLeft: 0 }}>
            WE&apos;RE SOCIAL
          </Typography>
          <Box>
            <SvgIcon component={Facebook} />
            <SvgIcon component={Twitter} />
            <SvgIcon component={LinkedIn} />
          </Box>
          <Box>
            <SvgIcon component={Instagram} />
            <SvgIcon component={YouTube} />
            <SvgIcon component={Reddit} />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: '1'
          }}
        />
      </Box>
    </Box>
  )
}

export default DemoEntryPt
